
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/u/[user]/achievements",
      function () {
        return require("private-next-pages/u/[user]/achievements.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/u/[user]/achievements"])
      });
    }
  